import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import ResumePageContent from './ResumePageContent'
import ResumePageHeader from './ResumePageHeader'
import Separator from '../../../components/helpers/Separator'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const ServiceOrderResumePage = ({ id }) => (
  <AbsolutePageTemplate>
    <ServiceOrderLoader id={id}>
      <ResumePageHeader />
      <Separator weight={4} />
      <FlexGrid align="stretch">
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
        <Separator weight={4} vertical hideOn="mdd" />

        <FlexCol flex={4}>
          <Container>
            <Separator weight={4} />
            <FlexGrid align="stretch" justify="flex-start" direction="column" gutter={0.5}>
              <ControlBar />

              <ResumePageContent id={id} />
            </FlexGrid>
            <Separator weight={4} />
          </Container>
        </FlexCol>

        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
      </FlexGrid>
    </ServiceOrderLoader>
  </AbsolutePageTemplate>
)

export default ServiceOrderResumePage
